import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-galaxy-skeleton',
  standalone: true,
  imports: [],
  template: `
    <div
      [style.width]="width"
      [style.height]="height"
      [style.border-radius]="borderRadius"
      class="skeleton-loader"
    ></div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .skeleton-loader {
        display: block;
        background: linear-gradient(
          -90deg,
          theme('colors.white / 4%') 0%,
          theme('colors.white / 10%') 50%,
          theme('colors.white / 4%') 100%
        );
        background-size: 400% 400%;
        animation: pulse 1.2s ease-in-out infinite;
      }

      @keyframes pulse {
        0% {
          background-position: 0% 0%;
        }
        100% {
          background-position: -135% 0%;
        }
      }
    `,
  ],
})
export class GalaxySkeletonComponent {
  @Input() width = '100%';
  @Input() height = '1rem';
  @Input() borderRadius = '0.25rem';
}
